module.exports = __webpack_public_path__ + "static/avatar.3ddd072a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 441
// module chunks = 168707334958949